import { render, staticRenderFns } from "./LargeLabelsNew.vue?vue&type=template&id=7d1b079c&scoped=true"
import script from "./LargeLabelsNew.vue?vue&type=script&lang=js"
export * from "./LargeLabelsNew.vue?vue&type=script&lang=js"
import style0 from "./LargeLabelsNew.vue?vue&type=style&index=0&id=7d1b079c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b079c",
  null
  
)

export default component.exports